// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.freemium.enums.RentalManagerFreemiumAnalyticsFilterType

export enum RentalManagerFreemiumAnalyticsFilterType {
  CITY_STATE = 'CITY_STATE',
  ZIP = 'ZIP',
}

export const RentalManagerFreemiumAnalyticsFilterType_values = [
  RentalManagerFreemiumAnalyticsFilterType.CITY_STATE,
  RentalManagerFreemiumAnalyticsFilterType.ZIP,
] as const;
